
module.exports = function (orderTrackerService) {
    return {
        restrict: 'E',
        scope: {
        },
        link(scope) {
            scope.isMobileScreen = window.innerWidth < 768;
            scope.orderTracker = orderTrackerService;

            scope.toogleOrderPanel = function () {
                orderTrackerService.toogle();
            };
        },
        template: require('./toolbar-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/toolbar/toolbar-directive.js
 **/